export default __webpack_public_path__ + "static/wand-education_medium_2-60cd6a5fb0572182006b44e9dc782fe0.webp";